import { render } from "./SpeechBubble.vue?vue&type=template&id=2b0a7ec0&scoped=true"
import script from "./SpeechBubble.vue?vue&type=script&lang=js"
export * from "./SpeechBubble.vue?vue&type=script&lang=js"

import "./SpeechBubble.vue?vue&type=style&index=0&id=2b0a7ec0&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0a7ec0"]])

export default __exports__